"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToEuro = convertToEuro;
exports.getAvailableCurrencies = getAvailableCurrencies;

var exchangeRates = require('./exchange_rates.json');

function convertToEuro(amount, currency) {
  if (currency.toUpperCase() === 'EUR') {
    return amount;
  }

  var exchangeRate = exchangeRates.rates[currency.toUpperCase()];

  if (!exchangeRate) {
    throw new Error("Unknown currency '".concat(currency, "'"));
  }

  return amount / exchangeRate;
}

function getAvailableCurrencies() {
  return Object.keys(exchangeRates.rates);
}